import React from "react";
import { store, core } from "./state";

export const StoreContext = React.createContext({ store, core });
